import {
  ChangeDetectionStrategy,
  Component,
  computed,
  input,
  OnInit,
  output,
} from '@angular/core';
import { SecurityReviewUpdate } from '../../abstractions/security-review-update';
import { timer } from 'rxjs';
import { fieldsValidators } from '@shared/constants/field-name-validators';
import { SecurityTaxResultItemForm } from '../../models/edit-tax-result-approval/security-tax-result-item-form';
import { TaxResultItemField } from '../../models/edit-tax-result-approval/tax-result-item-field';

@Component({
  standalone: false,
  selector: 'gstar-rate-field',
  templateUrl: './rate-field.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class RateFieldComponent implements OnInit {
  securityTaxResultItemForm = input.required<SecurityTaxResultItemForm>();
  isDisabled = input<boolean>(false);

  update = output<SecurityReviewUpdate>();

  rate = computed<TaxResultItemField>(() => {
    return this.securityTaxResultItemForm().rate!;
  });

  ngOnInit(): void {
    this.securityTaxResultItemForm().rate!.previousValue =
      this.securityTaxResultItemForm().rate!.value();
  }

  fieldUpdate(value: string): void {
    const normalizedValue = value.replace(/,/g, '.');

    if (this.isPercentage(normalizedValue)) {
      this.securityTaxResultItemForm().rate!.previousValue = normalizedValue;
    } else {
      timer(0).subscribe(() =>
        this.securityTaxResultItemForm().rate!.value.set(
          this.securityTaxResultItemForm().rate!.previousValue
        )
      );
    }
  }

  blurHandler(): void {
    this.update.emit({
      field: 'rate',
      metadata: this.securityTaxResultItemForm().rate!.metadata,
      securityTaxResultItem: this.securityTaxResultItemForm(),
    });
  }

  private isPercentage(value: string): boolean {
    const percentageValidator = fieldsValidators.decimalPercentage;
    return percentageValidator.test(value) || value === '';
  }
}
